// eslint-disable-next-line no-restricted-imports
import { Box, CircularProgress } from '@mui/material';

type SpinnerProps = {
  size?: number | string;
  centered?: boolean;
};

const Spinner = ({ size, centered = true }: SpinnerProps) => {
  const progress = <CircularProgress size={size} />;

  if (!centered) return progress;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        flex: 1
      }}
    >
      {progress}
    </Box>
  );
};

export default Spinner;
export { Spinner };
